// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__UKNfH","name":"ConsentHeader_name__1sPUL","birthday":"ConsentHeader_birthday__vUjKQ","skeleton":"ConsentHeader_skeleton__3_nMJ"};